import { useScrollReveal } from '../hooks/useScrollReveal';
import { Sparkles, BarChart3, Users, Tv } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const iconMap = [Sparkles, BarChart3, Tv, Users];

export const ComingSoonSection = () => {
  const [ref, isVisible] = useScrollReveal();
  const { t } = useLanguage();

  return (
    <section className="relative py-28 bg-[#0A0A0A]" ref={ref}>
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-[#C9A84C]/20 to-transparent" />
      <div className="max-w-7xl mx-auto px-6">
        <div className={`flex items-center gap-3 mb-6 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#C9A84C]/10 border border-[#C9A84C]/20 rounded-full">
            <span className="w-2 h-2 rounded-full bg-[#C9A84C] animate-pulse" />
            <span className="text-[#C9A84C] text-xs font-semibold tracking-[0.15em] uppercase">{t.comingSoon.badge}</span>
          </span>
        </div>
        <h2 className={`text-4xl sm:text-5xl font-bold text-[#F5F0E8] mb-6 font-heading transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>{t.comingSoon.headline}</h2>
        <p className={`text-lg text-[#9A9590] max-w-3xl mb-16 leading-relaxed transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>{t.comingSoon.description}</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {t.comingSoon.highlights.map((item, i) => {
            const Icon = iconMap[i];
            return (
              <div key={i} className={`group relative p-6 bg-[#111111] border border-[#1F1F1F] rounded-xl hover:border-[#C9A84C]/30 transition-all duration-500 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`} style={{ transitionDelay: `${300 + i * 100}ms` }}>
                <div className="w-10 h-10 rounded-lg bg-[#C9A84C]/10 flex items-center justify-center mb-4 group-hover:bg-[#C9A84C]/20 transition-colors duration-300"><Icon className="text-[#C9A84C]" size={20} /></div>
                <h3 className="text-[#F5F0E8] font-semibold text-base mb-2">{item.label}</h3>
                <p className="text-[#8A8680] text-sm leading-relaxed">{item.description}</p>
                <div className="absolute bottom-0 left-6 right-6 h-[1px] bg-[#C9A84C]/0 group-hover:bg-[#C9A84C]/30 transition-all duration-500" />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
